import { useUpdateProfile, useInvalidateProfile } from "../lib/api";
import { ProfileField, ProfileSection } from "./profile/ProfileField";
import {
  INTO_SUGGESTIONS,
  CONSUMING_SUGGESTIONS,
  LOOKING_TO_SUGGESTIONS,
} from "./profile/suggestions";

/**
 * The public-facing expressive layer of the profile: the "About you" prompts
 * (Things you're into / Currently watching, reading, listening to / Looking to).
 * Shown on the user's own profile (editable here) and mirrored on PublicProfile
 * (what others see on kikis / reach-outs). The bio lives in the hero card above
 * (see `ProfileBio`).
 */
export function ProfileAboutSection({
  interestTags,
  currentlyConsuming,
  lookingTo,
}: {
  interestTags: string[];
  currentlyConsuming: string[];
  lookingTo: string[];
}) {
  const updateProfile = useUpdateProfile();
  const invalidate = useInvalidateProfile();

  const save = (patch: Parameters<typeof updateProfile.mutate>[0]) =>
    updateProfile.mutate(patch, { onSuccess: () => invalidate() });

  return (
    <ProfileSection title="About you">
      <ProfileField
        kind="tags"
        label="Things you're into"
        sheetTitle="Add tags"
        value={interestTags}
        onSave={(v) => save({ interestTags: v })}
        suggestions={INTO_SUGGESTIONS}
      />
      <ProfileField
        kind="tags"
        label="Currently watching, reading, listening to"
        sheetTitle="Add tags"
        value={currentlyConsuming}
        onSave={(v) => save({ currentlyConsuming: v })}
        suggestions={CONSUMING_SUGGESTIONS}
      />
      <ProfileField
        kind="tags"
        label="Looking to"
        sheetTitle="Add tags"
        value={lookingTo}
        onSave={(v) => save({ lookingTo: v })}
        suggestions={LOOKING_TO_SUGGESTIONS}
      />
    </ProfileSection>
  );
}
